module.exports = __webpack_public_path__ + "img/20190611_113036_007.2148cdae.jpg";